<nx-card class="card-width col-container" [ngClass]="expandCard()">
  <div class="card-title-container justify_content_between">
    <div class="pr-pb-0">
      <h4
        nxHeadline="subsection-xsmall"
        class="nx-font-weight-bold no-margin text_left"
      >
        {{ data.campaignName }}
      </h4>
      <p nxCopytext="small" class="light-grey-color no-margin text_left">
        <i>as at {{ data.month }} {{ data.year }}</i>
      </p>
    </div>
    <div class="std-ta-center">
      <nx-icon
        [name]="getIconName(data?.category)"
        [ngClass]="getIconClass(data?.category)"
      ></nx-icon>
      <p
        nxCopytext="small"
        class="no-margin"
        [ngClass]="getIconText(data?.category)"
      >
        <b>{{ data?.category }}</b>
      </p>
    </div>
  </div>
  <div class="margin_top_20">
    <div nxRow>
      <div nxCol="12,12,12,12,5" class="justify_content_left">
        <nx-icon
          name="calendar"
          size="s"
          class="std-mg-right-2xs light-grey-color"
        ></nx-icon>
        <p nxCopytext="normal" class="no-margin">
          {{ formatDate(data?.startDate, "MMM YYYY") }} -
          {{ formatDate(data?.endDate, "MMM YYYY") }}
        </p>
      </div>
      <div nxCol="12,12,12,12,7" class="justify_content_left m_padding_top_10">
        <nx-icon
          name="file-text"
          size="s"
          class="std-mg-right-2xs light-grey-color"
        ></nx-icon>
        <p nxCopytext="normal" class="no-margin std-ta-left">
          {{ data?.criteria }}
        </p>
      </div>
    </div>

    <div nxRow class="margin_top_20">
      <div nxCol="12">
        <hr />
      </div>
    </div>
    @for (details of data?.groupList; track details) {
      <div nxRow class="campaign-details">
        <div nxCol="12">
          <p nxCopytext="large" class="margin_top_20 sub-content-style">
            @if (details.groupName) {
              <span>
                {{ formatBracketValue(details.groupName) }}
              </span>
            }
          </p>
        </div>
        @for (subDetails of details.subgroupList; track subDetails) {
          <div
            nxCol="12,12,6,6,4,4"
            class="details-column margin_top_20 margin_bottom_20"
          >
            <nx-data-display>
              <nx-data-display-label>
                {{ formatYearValue(subDetails.subgroupName) }}
              </nx-data-display-label>
              <span
                class="fw-semi-bold"
                [ngClass]="
                  identifyMomVariance(
                    subDetails.subgroupValue,
                    subDetails.subgroupName
                  )
                "
              >
                {{ subDetails.subgroupValue }}
              </span>
            </nx-data-display>
          </div>
        }
      </div>
    }
  </div>
</nx-card>
